
function withAdjacentDuplicatesRemoved( coordinates = [] ) {
    return coordinates.filter( ( coordinate, index ) => {
        if ( index === 0 ) {
            return true;
        }

        const previous = {
            lat: coordinates[ index - 1 ][ 1 ],
            lon: coordinates[ index - 1 ][ 0 ],
        };

        const lat = coordinate[ 1 ];
        const lon = coordinate[ 0 ];

        if ( previous.lat === lat && previous.lon === lon ) {
            return false;
        }

        return true;
    } );
}

function toFixed( number, maxDecimals = 5 ) {
    return parseFloat( number.toFixed( maxDecimals ) );
}

function truncateToFixed( number, maxDecimals = 5 ) {
    const numberStr = number.toString();
    const limit = maxDecimals + 1;
    const exp = new RegExp( `[0-9].[0-9]{${limit},}` );

    if ( !exp.test( numberStr ) ) {
        return number;
    }

    const split = numberStr.split( '.' );

    return parseFloat( split[ 0 ] + '.' + split[ 1 ].substring( 0, maxDecimals ) );
}

function withMaxDecimalPlaces( coordinates, maxDecimals = 5 ) {
    return coordinates.map( ( pair ) => {
        return pair.map( ( coord ) => truncateToFixed( coord, maxDecimals ) );
    } );
}

const processors = [
    withMaxDecimalPlaces,
    withAdjacentDuplicatesRemoved,
];

function sanitiseCoordinates( coordinates ) {
    let sanitised = coordinates;

    processors.forEach( ( processor ) => {
        if ( !Array.isArray( coordinates ) ) {
            throw new TypeError( 'expected value to be of type array' );
        }

        sanitised = processor( sanitised );
    } );

    return sanitised;
}

export {
    sanitiseCoordinates,
    truncateToFixed,
    toFixed,
};
